import type { LatLng, Map as LeafletMap, LeafletMouseEvent } from "leaflet"
import { useEffect } from "react"
import type { ReactElement } from "react"
import { useMap } from "react-leaflet"
;(window as any).isDebugMode = true

export function DebugLogger(): ReactElement {
  const mapReference: LeafletMap = useMap()

  function log(latlng: LatLng): void {
    navigator.clipboard.writeText(`${latlng.lat},${latlng.lng}`)
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    mapReference.off("click", (e: LeafletMouseEvent) => {
      if ((window as any).isDebugMode) log(e.latlng)
    })
    mapReference.on("click", (e: LeafletMouseEvent) => {
      if ((window as any).isDebugMode) log(e.latlng)
    })
  }, [mapReference, (window as any).isDebugMode])
  return <></>
}
